<div class="driver-details" *ngIf="passengerDetails != null">
  <div class="p-g panel-div">
    <div class="p-g-3 p-md-3 p-lg-3">
      <img class="user-pic" src="{{imageUrl}}" onerror="src='/assets/images/temp/default_profile.png'" />
    </div>
    <div class="p-g-9 p-md-9 p-lg-9 p-g-nopad mrg-top-10">
      <div class="p-g">
        <div class="p-g-12">
          <div class="info-label" translate>label_passenger_details_header</div>
        </div>
        <div class="p-g-3">
          <span class="info-label" translate>label_name</span>
          <span class="info-label">: </span>
        </div>
        <div class="p-g-9">
          <div>{{passengerDetails.firstName }} {{ passengerDetails.lastName}}</div>
        </div>
        <div class="p-g-3">
          <div class="info-label" translate>label_phone</div>
        </div>
        <div class="p-g-9">
          <div><span *ngIf="passengerDetails.numCountryCode!=null">+{{passengerDetails.numCountryCode}}</span>{{ passengerDetails.phoneNum }}</div>
        </div>
        <div class="p-g-3">
          <div class="info-label" translate>label_email</div>
        </div>
        <div class="p-g-9">
          <div>{{ passengerDetails.email }}</div>
        </div>
        <div class="p-g-12 p-g-nopad" *ngIf='passengerDetails.rating != null'>
          <div class="p-g-3">
            <div class="info-label" translate>rating_col</div>
          </div>
          <div class="p-g-9">
            <div>{{ passengerDetails.passengerRating }}</div>
          </div>
        </div>

        <div class="p-g-12 p-g-nopad" *ngIf='passengerDetails.addressLine1 != null && passengerDetails.addressLine1 != undefined && passengerDetails.addressLine1 != ""'>
          <div class="p-g-3">
            <div class="info-label" translate>address_col</div>
          </div>
          <div class="p-g-9">
            <div> <span>{{ passengerDetails.addressLine1 }}</span>
              <span *ngIf='passengerDetails.addressLine2!= null && passengerDetails.addressLine2!= undefined && passengerDetails.addressLine2 != ""'>
             {{passengerDetails.addressLine2}}
            </span>
              <span *ngIf='city != "" && city != undefined'>, {{city}}</span><span>, {{country}}</span><span>, {{passengerDetails.zipcode}}</span></div>

          </div>
        </div>

        <div class="p-g-12 p-g-nopad" *ngIf='bookingsCount != null'>
          <div class="p-g-3">
            <div class="info-label" translate>noOfBookings</div>
          </div>
          <div class="p-g-9">
            <div>{{ bookingsCount }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="p-g panel-div" *ngIf="passengerDetails == null">
  <div class="p-g-12">
    <div class="info-label" translate>message_passenger_not_assigned</div>
  </div>
</div>
